import React, { useState, useEffect } from "react";
import Wrapper from "../wrapper/Wrapper";
import { Container, Row, Col, Button, FormGroup, Tab, Tabs } from "react-bootstrap"; // attributes

var dontShow = ["Description", "Origin", "Vendor", "Bulk Quantity", "Collection", "Dropship"];
export var RetailAbout = function RetailAbout(props) {
  var shippingInformation = props.shippingInformation,
      attributes = props.attributes;
  var Description = attributes.Description,
      Origin = attributes.Origin,
      Size_Chart = attributes.Size_Chart;
  var propsArray = Object.entries(attributes).filter(function (prop) {
    return !(dontShow.indexOf(prop[0]) !== -1);
  }).map(function (prop) {
    return [prop[0].replace("_", " "), prop[1]];
  });
  return /*#__PURE__*/React.createElement(Wrapper, {
    layout: {
      background: "default",
      padding: "small"
    }
  }, /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(Row, {
    className: ""
  }, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement("h2", {
    className: "text-center cb-retail-detail__title"
  }, "About this Item"), /*#__PURE__*/React.createElement(Tabs, {
    defaultActiveKey: "details",
    id: "uncontrolled-tab-example",
    className: "mt-16"
  }, /*#__PURE__*/React.createElement(Tab, {
    eventKey: "details",
    title: "Details",
    className: "mt-16"
  }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    lg: "6",
    sm: "12"
  }, Boolean(Description) && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("p", {
    className: "cb-retail-detail__about-header"
  }, "Description"), /*#__PURE__*/React.createElement("p", {
    dangerouslySetInnerHTML: {
      __html: Description
    }
  })), Boolean(Origin) && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("p", {
    className: "cb-retail-detail__about-header"
  }, "Origin"), /*#__PURE__*/React.createElement("p", null, Origin))), /*#__PURE__*/React.createElement(Col, {
    lg: "6",
    sm: "12"
  }, /*#__PURE__*/React.createElement(ConditionalDetails, {
    details: propsArray
  })))), Boolean(Size_Chart) && /*#__PURE__*/React.createElement(Tab, {
    eventKey: "size",
    title: "Size Chart",
    className: "mt-16"
  }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement("p", {
    className: "cb-retail-detail__about-header"
  }, "Size Chart"), /*#__PURE__*/React.createElement("a", {
    href: "https://cbrl-ecom-images.s3.amazonaws.com/Apparel/Womens_size_chart_final.pdf",
    target: "_blank"
  }, "Click Here for Size Chart")))), /*#__PURE__*/React.createElement(Tab, {
    eventKey: "shipping",
    title: "Shipping Information",
    className: "mt-16"
  }, /*#__PURE__*/React.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: shippingInformation
    }
  })))))));
};

var ConditionalDetails = function ConditionalDetails(props) {
  var details = props.details;
  return details.map(function (detail, index) {
    return Boolean(detail[1]) ? /*#__PURE__*/React.createElement("div", {
      key: "ConditionalDetails" + index
    }, /*#__PURE__*/React.createElement("p", {
      className: "cb-retail-detail__about-header"
    }, detail[0]), /*#__PURE__*/React.createElement("p", {
      dangerouslySetInnerHTML: {
        __html: detail[1]
      }
    })) : null;
  });
};